import { CoreQuery } from '@/common/services/core-query';
import { EntitiesList } from '@/common/models';
import { httpClientCoreQuery } from '@/api/http-client';
import { DataRequestOptions, TablePaginatedData } from '@/common/components/table/v2/interfaces';
import { Topic } from '@/admin/topics/models/topic';

import { FluentFilterCollection, isNotEmpty, Operator } from '@/common/services';
import { Filter } from '@/reporting/models/segment';

export interface TopicSearchOptions extends DataRequestOptions {
    category_id?: number;
    topic_ids?: number[];
    filter?: Filter;
}

export function getTopics(options: TopicSearchOptions): Promise<TablePaginatedData<Topic>> {
    const filters = new FluentFilterCollection();

    if (isNotEmpty(options.searchQuery)) {
        filters.where('name').filter(Operator.Contains, options.searchQuery!);
    }

    if (options.category_id) {
        filters.where('category_id').filter(Operator.Have, options.category_id);
    }

    if (options.topic_ids) {
        filters.where('id').filter(Operator.IsEqualTo, options.topic_ids.join('|'));
    }

    if (options.filter?.mode) {
        if (options.filter.mode === 'inclusive') {
            filters.where('id').filter(Operator.IsEqualTo, options.filter?.selectedIds.join('|'));
        } else {
            options.filter.selectedIds.forEach(id => {
                filters.where('id').filter(Operator.IsNotEqualTo, id);
            });
        }
    }

    const q = new CoreQuery()
        .entity([EntitiesList.TOPICS, EntitiesList.PERSONA, EntitiesList.TOPIC])
        .filters(filters)
        .param({
            page: options.page,
            page_size: options.pageSize,
            sorts: '-id',
        });

    return httpClientCoreQuery.get<TablePaginatedData<Topic>>(q).then(({ data }) => data);
}
